<template>
  <div class="timer">
    <figure>
      <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <g>
          <circle cx="50" cy="50" r="45"></circle>
          <path
            ref="path"
            :stroke-dasharray="`${strokeDash} ${pathLength}`"
            d="
              M 50, 50
              m -45, 0
              a 45,45 0 1,0 90,0
              a 45,45 0 1,0 -90,0
            "
          ></path>
        </g>
      </svg>
      <figcaption>{{ displaySeconds }}</figcaption>
    </figure>
  </div>
</template>

<script>
import { INITIAL_TIME } from "../constants.js";
export default {
  name: "Timer",
  emits: ["stop"],
  props: {
    stopped: { type: Boolean, required: true },
    active: { type: Boolean, required: true },
  },
  data() {
    return {
      timeLeft: INITIAL_TIME,
      timer: "",
      startTime: -1,
      pathLength: -1,
    };
  },
  computed: {
    displaySeconds() {
      if (this.timeLeft >= 10) {
        return "0:" + this.timeLeft;
      } else {
        return "0:0" + this.timeLeft;
      }
    },
    strokeDash() {
      return Math.floor((this.timeLeft / INITIAL_TIME) * this.pathLength);
    },
  },
  watch: {
    stopped(stopped) {
      if (stopped) {
        clearInterval(this.timer);
        this.$emit("stop", this.timeLeft);
      }
    },
  },
  methods: {
    // todo: not sure where to log this comment but it would be nice
    // if the timer animation slightly _preceded_ the clock time
    countDown() {
      this.timer = setInterval(() => {
        this.timeLeft--;
        if (this.timeLeft <= 0) {
          clearInterval(this.timer);
          this.$emit("stop", 0);
          return;
        }
      }, 1000);
    },
  },
  mounted() {
    if (this.active) {
      this.startTime = Date.now();
      // https://jakearchibald.com/2013/animated-line-drawing-svg/
      this.pathLength = this.$refs.path.getTotalLength();
      this.countDown();
    }
  },
};
</script>

<style scoped lang="css">
.timer {
  text-align: center;
  height: 85px;
}

/* https://codepen.io/geoffgraham/pen/yLywVbW */
figure {
  margin: 0;
  height: 80px;
  width: 80px;
  position: absolute;
  left: calc(50% - 40px);
}

svg {
  overflow: hidden;
  transform: scaleX(-1);
  --timer-girth: 7px;
}

g {
  fill: none;
  stroke: none;
}

circle {
  stroke-width: var(--timer-girth);
  stroke: #ffefcf; /* fallback for IE, which is not to say that this works in IE */
  stroke: hsla(39.4, 100%, 53.1%, 0.2); /* clementine light-80 i think? */
}

path {
  stroke-width: var(--timer-girth);
  stroke-linecap: round;
  transform: rotate(90deg);
  transform-origin: center;
  transition: 0.1s linear all;
  fill-rule: nonzero;
  stroke: #ffad10; /* clementine */
}

figcaption {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: right;
  font-weight: bold;
}
</style>
